import React, { useState, useEffect } from "react";
import {
  Mail,
  Phone,
  Lock,
  Eye,
  EyeOff,
  User,
  ChevronDown,
  ArrowRight,
  AlertCircle,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import OtpVerification from "./OtpVerification";
import SuccessMessage from "./SuccessMessage";
import GoogleLoginButton from "../auth/GoogleLoginButton";

const BackendUrl = process.env.REACT_APP_Backend_Url;

// Liste des indicatifs téléphoniques populaires
const countryCodes = [
  { code: "+93", country: "Afghanistan", flag: "🇦🇫" },
  { code: "+355", country: "Albanie", flag: "🇦🇱" },
  { code: "+213", country: "Algérie", flag: "🇩🇿" },
  { code: "+376", country: "Andorre", flag: "🇦🇩" },
  { code: "+244", country: "Angola", flag: "🇦🇴" },
  { code: "+54", country: "Argentine", flag: "🇦🇷" },
  { code: "+374", country: "Arménie", flag: "🇦🇲" },
  { code: "+61", country: "Australie", flag: "🇦🇺" },
  { code: "+43", country: "Autriche", flag: "🇦🇹" },
  { code: "+994", country: "Azerbaïdjan", flag: "🇦🇿" },
  { code: "+1242", country: "Bahamas", flag: "🇧🇸" },
  { code: "+973", country: "Bahreïn", flag: "🇧🇭" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩" },
  { code: "+32", country: "Belgique", flag: "🇧🇪" },
  { code: "+229", country: "Bénin", flag: "🇧🇯" },
  { code: "+975", country: "Bhoutan", flag: "🇧🇹" },
  { code: "+591", country: "Bolivie", flag: "🇧🇴" },
  { code: "+387", country: "Bosnie-Herzégovine", flag: "🇧🇦" },
  { code: "+267", country: "Botswana", flag: "🇧🇼" },
  { code: "+55", country: "Brésil", flag: "🇧🇷" },
  { code: "+673", country: "Brunei", flag: "🇧🇳" },
  { code: "+359", country: "Bulgarie", flag: "🇧🇬" },
  { code: "+226", country: "Burkina Faso", flag: "🇧🇫" },
  { code: "+257", country: "Burundi", flag: "🇧🇮" },
  { code: "+855", country: "Cambodge", flag: "🇰🇭" },
  { code: "+237", country: "Cameroun", flag: "🇨🇲" },
  { code: "+1", country: "Canada", flag: "🇨🇦" },
  { code: "+238", country: "Cap-Vert", flag: "🇨🇻" },
  { code: "+236", country: "République centrafricaine", flag: "🇨🇫" },
  { code: "+235", country: "Tchad", flag: "🇹🇩" },
  { code: "+56", country: "Chili", flag: "🇨🇱" },
  { code: "+86", country: "Chine", flag: "🇨🇳" },
  { code: "+57", country: "Colombie", flag: "🇨🇴" },
  { code: "+242", country: "Congo", flag: "🇨🇬" },
  { code: "+243", country: "RD Congo", flag: "🇨🇩" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+225", country: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "+385", country: "Croatie", flag: "🇭🇷" },
  { code: "+53", country: "Cuba", flag: "🇨🇺" },
  { code: "+357", country: "Chypre", flag: "🇨🇾" },
  { code: "+420", country: "République tchèque", flag: "🇨🇿" },
  { code: "+45", country: "Danemark", flag: "🇩🇰" },
  { code: "+253", country: "Djibouti", flag: "🇩🇯" },
  { code: "+1809", country: "République dominicaine", flag: "🇩🇴" },
  { code: "+593", country: "Équateur", flag: "🇪🇨" },
  { code: "+20", country: "Égypte", flag: "🇪🇬" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻" },
  { code: "+240", country: "Guinée équatoriale", flag: "🇬🇶" },
  { code: "+291", country: "Érythrée", flag: "🇪🇷" },
  { code: "+372", country: "Estonie", flag: "🇪🇪" },
  { code: "+251", country: "Éthiopie", flag: "🇪🇹" },
  { code: "+679", country: "Fidji", flag: "🇫🇯" },
  { code: "+358", country: "Finlande", flag: "🇫🇮" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+241", country: "Gabon", flag: "🇬🇦" },
  { code: "+220", country: "Gambie", flag: "🇬🇲" },
  { code: "+995", country: "Géorgie", flag: "🇬🇪" },
  { code: "+49", country: "Allemagne", flag: "🇩🇪" },
  { code: "+233", country: "Ghana", flag: "🇬🇭" },
  { code: "+30", country: "Grèce", flag: "🇬🇷" },
  { code: "+299", country: "Groenland", flag: "🇬🇱" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹" },
  { code: "+224", country: "Guinée", flag: "🇬🇳" },
  { code: "+245", country: "Guinée-Bissau", flag: "🇬🇼" },
  { code: "+592", country: "Guyana", flag: "🇬🇾" },
  { code: "+509", country: "Haïti", flag: "🇭🇹" },
  { code: "+504", country: "Honduras", flag: "🇭🇳" },
  { code: "+852", country: "Hong Kong", flag: "🇭🇰" },
  { code: "+36", country: "Hongrie", flag: "🇭🇺" },
  { code: "+354", country: "Islande", flag: "🇮🇸" },
  { code: "+91", country: "Inde", flag: "🇮🇳" },
  { code: "+62", country: "Indonésie", flag: "🇮🇩" },
  { code: "+98", country: "Iran", flag: "🇮🇷" },
  { code: "+964", country: "Irak", flag: "🇮🇶" },
  { code: "+353", country: "Irlande", flag: "🇮🇪" },
  { code: "+972", country: "Israël", flag: "🇮🇱" },
  { code: "+39", country: "Italie", flag: "🇮🇹" },
  { code: "+1876", country: "Jamaïque", flag: "🇯🇲" },
  { code: "+81", country: "Japon", flag: "🇯🇵" },
  { code: "+962", country: "Jordanie", flag: "🇯🇴" },
  { code: "+7", country: "Kazakhstan", flag: "🇰🇿" },
  { code: "+254", country: "Kenya", flag: "🇰🇪" },
  { code: "+965", country: "Koweït", flag: "🇰🇼" },
  { code: "+996", country: "Kirghizistan", flag: "🇰🇬" },
  { code: "+856", country: "Laos", flag: "🇱🇦" },
  { code: "+371", country: "Lettonie", flag: "🇱🇻" },
  { code: "+961", country: "Liban", flag: "🇱🇧" },
  { code: "+266", country: "Lesotho", flag: "🇱🇸" },
  { code: "+231", country: "Libéria", flag: "🇱🇷" },
  { code: "+218", country: "Libye", flag: "🇱🇾" },
  { code: "+423", country: "Liechtenstein", flag: "🇱🇮" },
  { code: "+370", country: "Lituanie", flag: "🇱🇹" },
  { code: "+352", country: "Luxembourg", flag: "🇱🇺" },
  { code: "+853", country: "Macao", flag: "🇲🇴" },
  { code: "+389", country: "Macédoine du Nord", flag: "🇲🇰" },
  { code: "+261", country: "Madagascar", flag: "🇲🇬" },
  { code: "+265", country: "Malawi", flag: "🇲🇼" },
  { code: "+60", country: "Malaisie", flag: "🇲🇾" },
  { code: "+960", country: "Maldives", flag: "🇲🇻" },
  { code: "+223", country: "Mali", flag: "🇲🇱" },
  { code: "+356", country: "Malte", flag: "🇲🇹" },
  { code: "+222", country: "Mauritanie", flag: "🇲🇷" },
  { code: "+230", country: "Maurice", flag: "🇲🇺" },
  { code: "+52", country: "Mexique", flag: "🇲🇽" },
  { code: "+373", country: "Moldavie", flag: "🇲🇩" },
  { code: "+377", country: "Monaco", flag: "🇲🇨" },
  { code: "+976", country: "Mongolie", flag: "🇲🇳" },
  { code: "+382", country: "Monténégro", flag: "🇲🇪" },
  { code: "+212", country: "Maroc", flag: "🇲🇦" },
  { code: "+258", country: "Mozambique", flag: "🇲🇿" },
  { code: "+95", country: "Myanmar", flag: "🇲🇲" },
  { code: "+264", country: "Namibie", flag: "🇳🇦" },
  { code: "+977", country: "Népal", flag: "🇳🇵" },
  { code: "+31", country: "Pays-Bas", flag: "🇳🇱" },
  { code: "+64", country: "Nouvelle-Zélande", flag: "🇳🇿" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "+227", country: "Niger", flag: "🇳🇪" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+850", country: "Corée du Nord", flag: "🇰🇵" },
  { code: "+47", country: "Norvège", flag: "🇳🇴" },
  { code: "+968", country: "Oman", flag: "🇴🇲" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { code: "+970", country: "Palestine", flag: "🇵🇸" },
  { code: "+507", country: "Panama", flag: "🇵🇦" },
  { code: "+675", country: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾" },
  { code: "+51", country: "Pérou", flag: "🇵🇪" },
  { code: "+63", country: "Philippines", flag: "🇵🇭" },
  { code: "+48", country: "Pologne", flag: "🇵🇱" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+974", country: "Qatar", flag: "🇶🇦" },
  { code: "+40", country: "Roumanie", flag: "🇷🇴" },
  { code: "+7", country: "Russie", flag: "🇷🇺" },
  { code: "+250", country: "Rwanda", flag: "🇷🇼" },
  { code: "+966", country: "Arabie saoudite", flag: "🇸🇦" },
  { code: "+221", country: "Sénégal", flag: "🇸🇳" },
  { code: "+381", country: "Serbie", flag: "🇷🇸" },
  { code: "+232", country: "Sierra Leone", flag: "🇸🇱" },
  { code: "+65", country: "Singapour", flag: "🇸🇬" },
  { code: "+421", country: "Slovaquie", flag: "🇸🇰" },
  { code: "+386", country: "Slovénie", flag: "🇸🇮" },
  { code: "+252", country: "Somalie", flag: "🇸🇴" },
  { code: "+27", country: "Afrique du Sud", flag: "🇿🇦" },
  { code: "+82", country: "Corée du Sud", flag: "🇰🇷" },
  { code: "+34", country: "Espagne", flag: "🇪🇸" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "+249", country: "Soudan", flag: "🇸🇩" },
  { code: "+211", country: "Soudan du Sud", flag: "🇸🇸" },
  { code: "+597", country: "Suriname", flag: "🇸🇷" },
  { code: "+268", country: "Eswatini", flag: "🇸🇿" },
  { code: "+46", country: "Suède", flag: "🇸🇪" },
  { code: "+41", country: "Suisse", flag: "🇨🇭" },
  { code: "+963", country: "Syrie", flag: "🇸🇾" },
  { code: "+886", country: "Taïwan", flag: "🇹🇼" },
  { code: "+992", country: "Tadjikistan", flag: "🇹🇯" },
  { code: "+255", country: "Tanzanie", flag: "🇹🇿" },
  { code: "+66", country: "Thaïlande", flag: "🇹🇭" },
  { code: "+228", country: "Togo", flag: "🇹🇬" },
  { code: "+216", country: "Tunisie", flag: "🇹🇳" },
  { code: "+90", country: "Turquie", flag: "🇹🇷" },
  { code: "+993", country: "Turkménistan", flag: "🇹🇲" },
  { code: "+256", country: "Ouganda", flag: "🇺🇬" },
  { code: "+380", country: "Ukraine", flag: "🇺🇦" },
  { code: "+971", country: "Émirats arabes unis", flag: "🇦🇪" },
  { code: "+44", country: "Royaume-Uni", flag: "🇬🇧" },
  { code: "+1", country: "États-Unis", flag: "🇺🇸" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾" },
  { code: "+998", country: "Ouzbékistan", flag: "🇺🇿" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳" },
  { code: "+967", country: "Yémen", flag: "🇾🇪" },
  { code: "+260", country: "Zambie", flag: "🇿🇲" },
  { code: "+263", country: "Zimbabwe", flag: "🇿🇼" },
];

function InscriptionWithOTP({ chg }) {
  const [currentStep, setCurrentStep] = useState('form');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpToken, setOtpToken] = useState('');
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    passwordConf: "",
    countryCode: "+227",
    whatsapp: true,
  });

  const [errors, setErrors] = useState([]);
  const [isEmailRequired, setIsEmailRequired] = useState(false);
  const [isPhoneRequired, setIsPhoneRequired] = useState(false);

  const navigation = useNavigate();
  const regexPhone = /^[0-9]{8,}$/;

  // Fermer le dropdown si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && !event.target.closest(".country-dropdown")) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCountryDropdown]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    const minLength = 8;
    const regexUpperCase = /[A-Z]/;
    const regexLowerCase = /[a-z]/;
    const regexNumber = /[0-9]/;
    const regexSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

    const errors = [];

    if (!password || password.length < minLength) {
      errors.push("Le mot de passe doit contenir au moins 8 caractères.");
    }
    if (!regexUpperCase.test(password)) {
      errors.push("Le mot de passe doit contenir au moins une lettre majuscule.");
    }
    if (!regexLowerCase.test(password)) {
      errors.push("Le mot de passe doit contenir au moins une lettre minuscule.");
    }
    if (!regexNumber.test(password)) {
      errors.push("Le mot de passe doit contenir au moins un chiffre.");
    }
    // if (!regexSpecialChar.test(password)) {
    //   errors.push("Le mot de passe doit contenir au moins un caractère spécial.");
    // }

    return errors;
  };

  const validateForm = () => {
    const newErrors = [];
    const { name, email, phoneNumber, password, passwordConf } = formData;

    // Validation du nom
    if (!name.trim() || name.length < 3) {
      newErrors.push("Veuillez entrer un nom valide d'au moins 3 caractères.");
    }

    // Validation du mot de passe
    const passwordErrors = validatePassword(password);
    newErrors.push(...passwordErrors);

    // Validation de la confirmation du mot de passe
    if (passwordConf !== password) {
      newErrors.push("Les deux mots de passe ne correspondent pas.");
    }

    // Validation de l'email si renseigné
    if (email && !validateEmail(email)) {
      newErrors.push("Veuillez entrer une adresse e-mail valide.");
    }

    // Validation du numéro de téléphone si renseigné
    if (phoneNumber && !regexPhone.test(phoneNumber)) {
      newErrors.push("Veuillez entrer un numéro de téléphone valide (minimum 8 chiffres).");
    }

    // Vérifier qu'au moins un des deux champs (email ou téléphone) est rempli
    if (!email && !phoneNumber) {
      newErrors.push("Veuillez fournir une adresse e-mail ou un numéro de téléphone.");
    }

    // L'email est obligatoire pour la vérification OTP
    if (!email) {
      newErrors.push("L'adresse e-mail est obligatoire pour la vérification.");
    }

    setErrors(newErrors);
    return newErrors.length === 0;
  };

  const handleSendOTP = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${BackendUrl}/api/user/send-otp`, {
        email: formData.email,
        name: formData.name,
      });

      if (response.status === 200) {
        setCurrentStep('otp');
      }
    } catch (error) {
      if (error.response) {
        setErrors([error.response.data.message || "Erreur lors de l'envoi du code OTP"]);
      } else {
        setErrors(["Problème de connexion au serveur."]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOTPVerification = async (token) => {
    setOtpToken(token);
    setIsLoading(true);

    try {
      const formattedPhoneNumber = formData.phoneNumber
        ? `${formData.countryCode}${formData.phoneNumber}`
        : null;

      // Créer l'utilisateur après vérification OTP
      const response = await axios.post(`${BackendUrl}/api/user/register-with-otp`, {
        name: formData.name,
        email: formData.email,
        phoneNumber: formattedPhoneNumber,
        password: formData.password,
        whatsapp: formData.whatsapp,
        otpToken: token,
      });

      if (response.status === 201) {
        // Connecter automatiquement l'utilisateur
        const loginResponse = await axios.post(
          `${BackendUrl}/api/user/login`,
          {
            email: formData.email,
            phoneNumber: formattedPhoneNumber,
            password: formData.password,
          },
          {
            withCredentials: true,
            credentials: "include",
          }
        );

        if (loginResponse.status === 200) {
          localStorage.setItem(`userEcomme`, JSON.stringify(loginResponse.data));
          setCurrentStep('success');
          
          // Redirection automatique après 3 secondes
          setTimeout(() => {
            navigateBasedOnLocation();
            chg("oui");
          }, 3000);
        }
      }
    } catch (error) {
      if (error.response) {
        setErrors([error.response.data.message || "Erreur lors de la création du compte"]);
      } else {
        setErrors(["Problème de connexion au serveur."]);
      }
      setCurrentStep('form');
    } finally {
      setIsLoading(false);
    }
  };

  const navigateBasedOnLocation = () => {
    const location = new URLSearchParams(window.location.search);
    const destinations = {
      fromCart: "/NotificationHeader",
      fromProfile: "/Profile",
      fromMore: "/More",
      fromMessages: "/Messages",
    };

    for (const [key, path] of Object.entries(destinations)) {
      if (location.get(key)) {
        navigation(`${path}?${key}=true`);
        return;
      }
    }
    navigation("/Home");
  };

  const handleToggleRequired = (field) => {
    if (field === "email") {
      setIsEmailRequired((prev) => !prev);
      if (!isEmailRequired && isPhoneRequired) {
        setIsPhoneRequired(false);
      }
    } else if (field === "phone") {
      setIsPhoneRequired((prev) => !prev);
      if (!isPhoneRequired && isEmailRequired) {
        setIsEmailRequired(false);
      }
    }
  };

  const updateFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors.length > 0) {
      setErrors([]);
    }
  };

  // Rendu conditionnel basé sur l'étape actuelle
  if (currentStep === 'otp') {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <OtpVerification
          email={formData.email}
          onVerificationSuccess={handleOTPVerification}
          onBack={() => setCurrentStep('form')}
          isLoading={isLoading}
        />
      </div>
    );
  }

  if (currentStep === 'success') {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <SuccessMessage
          name={formData.name}
          email={formData.email}
          onContinue={() => {
            navigateBasedOnLocation();
            chg("oui");
          }}
        />
      </div>
    );
  }

  // Formulaire d'inscription (étape 1)
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <div className="mx-auto w-20 h-20 bg-[#008751] rounded-full flex items-center justify-center mb-4">
            <span className="text-white font-bold text-2xl">K</span>
          </div>
          <h2 className="mt-6 text-3xl font-bold text-[#E87E04]">
            CRÉER UN COMPTE
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Rejoignez Kassarmoumarket aujourd'hui
          </p>
        </div>

        {/* Affichage des erreurs */}
        {errors.length > 0 && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <div className="flex items-start">
              <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-red-800 mb-1">
                  Veuillez corriger les erreurs suivantes :
                </h3>
                <ul className="text-sm text-red-700 space-y-1">
                  {errors.map((error, index) => (
                    <li key={index}>• {error}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSendOTP} className="space-y-6">
          {/* Nom complet */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Nom complet <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={(e) => updateFormData('name', e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                placeholder="John Doe"
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Adresse email <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={(e) => updateFormData('email', e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                placeholder="vous@exemple.com"
              />
            </div>
            <p className="mt-1 text-xs text-gray-500">
              Un code de vérification sera envoyé à cette adresse
            </p>
          </div>

          {/* Numéro de téléphone avec indicatif */}
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
              Numéro de téléphone (optionnel)
            </label>
            <div className="mt-1 flex rounded-md shadow-sm">
              {/* Indicatif pays */}
              <div className="relative country-dropdown">
                <button
                  type="button"
                  className="relative inline-flex items-center px-3 py-2 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#008751] focus:border-[#008751]"
                  onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                >
                  <span>
                    {countryCodes.find((c) => c.code === formData.countryCode)?.flag}{" "}
                    {formData.countryCode}
                  </span>
                  <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                {showCountryDropdown && (
                  <div className="absolute z-10 mt-1 w-56 bg-white shadow-lg max-h-60 rounded-md py-1 ring-1 ring-black ring-opacity-5 overflow-auto">
                    {countryCodes.map((country) => (
                      <div
                        key={country.code}
                        className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          updateFormData('countryCode', country.code);
                          setShowCountryDropdown(false);
                        }}
                      >
                        <span className="mr-2">{country.flag}</span>
                        <span>{country.country}</span>
                        <span className="ml-auto">{country.code}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Champ numéro */}
              <div className="relative flex-1">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Phone className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    updateFormData('phoneNumber', value);
                  }}
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-r-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                  placeholder="Numéro sans indicatif"
                />
              </div>
            </div>
            {formData.phoneNumber && (
              <div className="mt-1 flex items-center">
                <input
                  id="whatsapp"
                  name="whatsapp"
                  type="checkbox"
                  checked={formData.whatsapp}
                  onChange={(e) => updateFormData('whatsapp', e.target.checked)}
                  className="h-4 w-4 text-[#008751] focus:ring-[#008751] border-gray-300 rounded"
                />
                <label htmlFor="whatsapp" className="ml-2 text-xs text-gray-500">
                  Ce numéro est également mon WhatsApp
                </label>
              </div>
            )}
          </div>

          {/* Mot de passe */}
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Mot de passe <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                value={formData.password}
                onChange={(e) => updateFormData('password', e.target.value)}
                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                placeholder="Votre mot de passe"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500"
                >
                  {showPassword ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
                </button>
              </div>
            </div>
            <p className="mt-1 text-xs text-gray-500">
              Minimum 8 caractères avec majuscule, minuscule, chiffre et caractère spécial
            </p>
          </div>

          {/* Confirmer mot de passe */}
          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
              Confirmer le mot de passe <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                required
                value={formData.passwordConf}
                onChange={(e) => updateFormData('passwordConf', e.target.value)}
                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#008751] focus:border-[#008751] sm:text-sm"
                placeholder="Confirmez votre mot de passe"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500"
                >
                  {showConfirmPassword ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
                </button>
              </div>
            </div>
          </div>

          {/* Information OTP */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Mail className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="text-sm text-blue-800">
                <p className="font-medium mb-1">Vérification par email</p>
                <p>
                  Un code de vérification sera envoyé à votre adresse email pour confirmer 
                  votre identité avant la création de votre compte.
                </p>
              </div>
            </div>
          </div>

          {/* Conditions d'utilisation */}
          <div className="flex items-center">
            <input
              id="terms"
              name="terms"
              type="checkbox"
              required
              className="h-4 w-4 text-[#008751] focus:ring-[#008751] border-gray-300 rounded"
            />
            <label htmlFor="terms" className="ml-2 block text-sm text-gray-900">
              J'accepte les{" "}
              <span onClick={() => navigation("/CGVPage")} className="font-medium text-[#008751] hover:text-[#006d40] cursor-pointer">
                conditions d'utilisation
              </span>{" "}
              et la{" "}
              <span onClick={() => navigation("/PolitiqueConfidentialitePage")} className="font-medium text-[#008751] hover:text-[#006d40] cursor-pointer">
                politique de confidentialité
              </span>
            </label>
          </div>

          {/* Bouton de soumission */}
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex justify-center items-center space-x-2 py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#008751] hover:bg-[#006d40] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#008751] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Envoi du code...</span>
                </>
              ) : (
                <>
                  <span>Continuer</span>
                  <ArrowRight className="w-4 h-4" />
                </>
              )}
            </button>
          </div>
        </form>

        {/* Séparateur */}
        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">
              Ou inscrivez-vous avec
            </span>
          </div>
        </div>

        {/* Bouton Google */}
        <GoogleLoginButton text="S'inscrire avec Google" />

        {/* Lien connexion */}
        <p className="mt-6 text-center text-sm text-gray-500">
          Déjà membre ?{" "}
          <span
            onClick={() => navigation("/Connexion")}
            className="font-medium text-[#008751] hover:text-[#006d40] cursor-pointer"
          >
            Connectez-vous
          </span>
        </p>
      </div>
    </div>
  );
}

export default InscriptionWithOTP;